import request from '@/utils/request'

const api = {
  Query(data) {
    return request({
      url: '/admin/LogDetails/list',
      method: 'post',
      data
    })
  },
  PvList(data) {
    return request({
      url: '/admin/LogDetails/pvList',
      method: 'post',
      data
    })
  },
  UvList(data) {
    return request({
      url: '/admin/LogDetails/uvList',
      method: 'post',
      data
    })
  }

}
export default api
